// extracted by mini-css-extract-plugin
export default {"head":"List_head__gkfLq","headMain":"List_headMain__KinKu","pad0":"List_pad0__vknd9","id":"List_id__M9IDp","btntbl":"List_btntbl__ygIIH","btns":"List_btns__-u7P5"};